import { memo } from 'react';

import { DateRangeFilter } from '../../../../components/PageFilters/filters/DateRangeFilter';
import type { PageFilterProps } from '../../../../components/PageFilters/types';

export const dateCreatedFilterKey = 'workspace-date-created-filter';

type DateCreatedValue = {
  dateStart?: string;
  dateEnd?: string;
};

export const DateCreatedFilter = memo((props: PageFilterProps<DateCreatedValue>) => {
  return <DateRangeFilter {...props} startLabel="Date created start" endLabel="Date created end" />;
});
